module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.07689d4e.ttf";